import store from "@frameworks/web/redux/store";
import { BROKER_CHARGES_DATA, BROKER_CHARGES_ERROR_DATA, BROKER_CHARGES_HIDE_ERROR_DATA, BROKER_CHARGES_START_LOADER, BROKER_CHARGES_STOP_LOADER, } from "../interface/IBrokerCharges";
class BrokerChargesActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getBrokerCharges(checkMargin) {
        this.dispatch({
            type: BROKER_CHARGES_DATA,
            payload: { brokerCharges: checkMargin },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: BROKER_CHARGES_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: BROKER_CHARGES_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: BROKER_CHARGES_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: BROKER_CHARGES_STOP_LOADER,
        });
    }
}
export default BrokerChargesActions;
